export const constants = {
  PREFIX: 'signage-',
};

export const localStorageLabels = {
  // AUTH_DETAILS: constants.PREFIX + 'auth-details',
  PROOF: 'proofs',
  TID: 'tid',
  LOCAL_DATA: 'localData',
  DEVICE_INFO: 'DeviceInfo',
  DEVICE_META: 'deviceMeta',
};
